import React from 'react';
import { ArrowDirection } from '@sales-portal/domain/pricing/screens/management/types';
import { getDeltaAttributes } from '@sales-portal/domain/pricing/screens/management/blocs/utils/table-ui';
import { Typography, TypographyVariant } from '@usepepper/ui/atoms/typography';
import { useTheme } from '@/contexts/theme-context';
import { XStack } from '@usepepper/sprout-kit-ui';

interface Props {
  direction?: ArrowDirection;
  text: string;
  variant?: TypographyVariant;
}

export const PricingDirectionalValue: React.FC<Props> = ({
  direction,
  text,
  variant = 'paragraph-md',
}) => {
  const theme = useTheme();
  const { color, Icon } = getDeltaAttributes(direction, theme);

  return (
    <XStack alignItems="center" gap={theme.sk.spacing.spaceXsmall}>
      <Typography variant={variant}>{text}</Typography>
      {Icon ? <Icon fill={color} height={8} stroke={color} width={8} /> : null}
    </XStack>
  );
};
